<!--
  功能：新增代理商
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2021年06月02日 16:21:23
  版本：v2.5.0
-->
<template>
  <div>
    <el-dialog :title="title" :visible="showDialog" @close="btnCancel()" :close-on-click-modal="false">
      <el-form ref="agentFormRef" :model="agentForm" :rules="agentFormRules" label-width="120px">
        <el-form-item label="代理商名称" prop="name">
          <el-input v-model="agentForm.name" placeholder="请输入代理商名称"></el-input>
        </el-form-item>
        <el-form-item label="代理商公司" prop="agencyCompany">
          <el-input v-model="agentForm.agencyCompany" placeholder="请输入代理商公司"></el-input>
        </el-form-item>
        <el-form-item label="媒体平台">
          <el-select v-model="platformType" disabled>
            <el-option :label="platformType" :value="platformType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点比例" prop="agentAppType">
          <el-row>
            <el-col :span="13">
              <el-select class="selectagent" v-model="agentForm.mediaType" placeholder="请选择">
                <el-option label="头条" :value="1"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10"><el-input class="iprebateratio" type="number" v-model.lazy="agentForm.rebatesProportion"></el-input></el-col>
            <el-col :span="1"><i>%</i></el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="footer">
          <div class="btn">
            <el-button size="small" @click="btnCancel()">取 消</el-button>
            <el-button size="small" type="primary" @click="createAgentSubmit()">确 定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { notNullable, strMax } from '@/components/form/formValidation'
export default {
  // 组件名称
  name: 'add-agent',
  // 组件参数 接收来自父组件的数据
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      isUpdate: false,
      cshowDialog: false,
      agentForm: {
        agentId: 0,
        name: '',
        agencyCompany: '',
        mediaType: 1,
        rebatesProportion: 0
      },

      agentFormRules: {
        name: [notNullable('请输入代理商名称'), strMax('代理商名称过长,不能超出20个字符', 20)],
        agencyCompany: [notNullable('请输入代理商公司'), strMax('代理商公司过长,不能超出20个字符', 20)]
      }
    }
  },
  // 计算属性
  computed: {
    title() {
      return this.isUpdate ? '编辑代理商' : '新增代理商'
    },
    platformType() {
      return this.$route.path.startsWith('/qianchuan') ? '巨量千川' : '巨量引擎'
    }
  },
  // 侦听器
  watch: {
    'agentForm.rebatesProportion'(newVal) {
      const parseResult = parseInt(newVal)
      if (isNaN(parseResult) || parseResult < 1) {
        this.agentForm.rebatesProportion = NaN
      } else {
        let index = String(newVal).indexOf('.')
        if (index !== -1) {
          this.agentForm.rebatesProportion = String(newVal).substring(0, index + 3)
          // this.agentForm.rebatesProportion = parseResult
        }
      }
    }
  },
  emits: ['updateAgentList'],
  // 组件方法
  methods: {
    btnCancel() {
      this.$emit('update:showDialog', false)
      this.$refs.agentFormRef.resetFields()
    },
    createAgentSubmit() {
      this.$refs.agentFormRef.validate(async valid => {
        if (valid) {
          let url = '/api/enterprise/agency/save'
          let msg = '添加成功!'
          if (this.isUpdate) {
            url = '/api/enterprise/agency/update/save'
            msg = '修改成功!'
          }
          try {
            this.agentForm.platformType = parseInt(localStorage.platformType)
            const res = await this.$service.post(url, this.agentForm)
            if (res.code === 200) {
              this.$message.success(msg)
              this.$emit('update:showDialog', false)
              this.$emit('updateAgentList', '')
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    showEditAgent(agentInfo) {
      console.log(agentInfo)
      this.isUpdate = true
      this.agentForm.name = agentInfo.name
      this.agentForm.agencyCompany = agentInfo.agencyCompany
      this.agentForm.rebatesProportion = agentInfo.rebatesProportion
      this.agentForm.id = agentInfo.id
      this.agentForm.mediaType = agentInfo.mediaType
    }
  },
  // 组件在内存中被创建
  created() {
    console.log('created dl')
  },
  /**
   * 组件被渲染到页面
   */
  mounted() {}
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/views/accountManage/agentmanage/components/add-agent.vue